/**
 * Desktop, calque .image-banner-with-text__decor-floats :
 * - Colonne 1, positions « top » : décalage = hauteur du heading
 * - Colonne 2, positions « bottom » : décalage = partie de l’image recouverte par le bloc texte (chevauchement)
 */
(function () {
  var MQ_DESKTOP = '(min-width: 990px)';

  function getRoot(floats) {
    return floats.closest('.image-banner-with-text');
  }

  function applyHeadingShift(floats) {
    if (floats.getAttribute('data-decor-heading-shift') !== 'true') return;

    if (!window.matchMedia(MQ_DESKTOP).matches) {
      floats.style.removeProperty('--decor-heading-shift');
      return;
    }

    var root = getRoot(floats);
    var heading = root ? root.querySelector('.image-with-text__heading-item') : null;
    var h = heading ? Math.round(heading.getBoundingClientRect().height) : 0;
    floats.style.setProperty('--decor-heading-shift', h + 'px');
  }

  /**
   * Hauteur (px) de la zone de l’image centrale recouverte par le bloc texte,
   * pour placer l’overlay en bas à droite/gauche sur la partie encore visible.
   */
  function applyCol2TextOverlap(floats) {
    if (floats.getAttribute('data-decor-col2-bottom-overlap') !== 'true') return;

    if (!window.matchMedia(MQ_DESKTOP).matches) {
      floats.style.removeProperty('--decor-col2-text-overlap');
      return;
    }

    var root = getRoot(floats);
    var slot2 = floats.querySelector('.image-banner-with-text__decor-floats__slot.image2');
    var textItem = root ? root.querySelector('.image-with-text__text-item') : null;

    if (!slot2 || !textItem) {
      floats.style.setProperty('--decor-col2-text-overlap', '0px');
      return;
    }

    var rImg = slot2.getBoundingClientRect();
    var rTxt = textItem.getBoundingClientRect();

    var horizontalOverlap = rTxt.right > rImg.left && rTxt.left < rImg.right;
    if (!horizontalOverlap) {
      floats.style.setProperty('--decor-col2-text-overlap', '0px');
      return;
    }

    var overlapPx = 0;
    if (rTxt.top < rImg.bottom && rTxt.bottom > rImg.top) {
      overlapPx = Math.min(
        rImg.height,
        Math.max(0, rImg.bottom - Math.max(rTxt.top, rImg.top))
      );
    }

    floats.style.setProperty('--decor-col2-text-overlap', Math.round(overlapPx) + 'px');
  }

  function applyAll(floats) {
    applyHeadingShift(floats);
    applyCol2TextOverlap(floats);
  }

  function bindDecorFloats(floats) {
    if (!floats || floats._imageBannerDecorJsBound) return;
    floats._imageBannerDecorJsBound = true;

    var run = function () {
      applyAll(floats);
    };

    run();
    window.addEventListener('resize', run);

    var root = getRoot(floats);

    if (floats.getAttribute('data-decor-heading-shift') === 'true') {
      var heading = root ? root.querySelector('.image-with-text__heading-item') : null;
      if (heading && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(run).observe(heading);
      }
    }

    if (floats.getAttribute('data-decor-col2-bottom-overlap') === 'true') {
      var textItem = root ? root.querySelector('.image-with-text__text-item') : null;
      var slot2 = floats.querySelector('.image-banner-with-text__decor-floats__slot.image2');
      if (typeof ResizeObserver !== 'undefined') {
        if (textItem) new ResizeObserver(run).observe(textItem);
        if (slot2) new ResizeObserver(run).observe(slot2);
      }
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run).catch(function () {});
    }
  }

  function initScope(scope) {
    var root = scope || document;
    root.querySelectorAll('.image-banner-with-text__decor-floats').forEach(function (floats) {
      var a = floats.getAttribute('data-decor-heading-shift') === 'true';
      var b = floats.getAttribute('data-decor-col2-bottom-overlap') === 'true';
      if (a || b) bindDecorFloats(floats);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScope();
    });
  } else {
    initScope();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });
})();
